// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__26B8c","marketplaceStroke":"IconEmailAttention_marketplaceStroke__3fC-O","attentionStroke":"IconEmailAttention_attentionStroke__9WKb7"};